/*! Oruga v0.8.12 | MIT License | github.com/oruga-ui/oruga */
import { _ as _sfc_main } from "./Select.vue_vue_type_script_setup_true_lang-CL_yS9EM.mjs";
import { b as registerComponent } from "./config-C1k5NuG7.mjs";
const index = {
  install(app) {
    registerComponent(app, _sfc_main);
  }
};
export {
  _sfc_main as OSelect,
  index as default
};
//# sourceMappingURL=select.mjs.map
